import React, { useMemo } from "react";
import { Trash2 } from "lucide-react";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import { useHistoricoEntrega } from "../context/HistoricoEntregaContext";
import type { TableAction } from "../../../../utils/tableActions";

const HistoricoEntregaTable: React.FC = () => {
  const {
    entregas,
    isLoading,
    formatDate,
    formatTime,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    setCurrentPage,
    handleDelete,
    isAdministrator,
  } = useHistoricoEntrega();

  const tableData = entregas.map((entrega) => [
    formatDate(entrega.dataInicio),
    formatDate(entrega.dataFim),
    entrega.loja?.nome || "-",
    entrega.entregador?.nome || "-",
    entrega.quantidadeEnderecos?.toString() || "0",
    formatTime(entrega.tempoTotal),
    entrega.status || "-",
    formatDate(entrega.createdAt),
  ]);

  const tableActions: TableAction[] | undefined = useMemo(() => {
    if (!isAdministrator) return undefined;
    return [
      {
        icon: <Trash2 size={16} />,
        onClick: handleDelete,
        className: "text-red-600 hover:text-red-900",
      },
    ];
  }, [isAdministrator, handleDelete]);

  if (isLoading) {
    return (
      <div className="rounded-lg bg-white p-6 shadow">
        <div className="text-center text-neutral-500">Carregando...</div>
      </div>
    );
  }

  return (
    <>
      <Table
        headers={[
          "Data Início",
          "Data Fim",
          "Loja",
          "Entregador",
          "Qtd. Endereços",
          "Tempo Total",
          "Status",
          "Data Criação",
        ]}
        data={tableData}
        actions={tableActions}
        actionsColumnTitle="Opções"
      />
      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}
    </>
  );
};

export default HistoricoEntregaTable;
